// StyledTextarea.js
import styled from "styled-components";

import React, { useContext } from "react";

import { FormBuilderContext } from "../context/context";
const StyledTextareaBase = styled.textarea`
  outline: none;
  height: ${({ styling }) => `${styling.textAreaHeight}px`};
  width: ${({ styling }) => `${styling.textAreaWidth}${styling.textAreaWidthUnits}`};
  border-width: ${({ styling }) => `${styling.textAreaBorderWidth}px`};
  border-style: ${({ styling }) => `${styling.textareaBorderStyleCheckbox}`};
  border-color: ${({ styling }) => styling.textAreaBorderColor};
  border-bottom: ${({ styling }) => `solid ${styling.textAreaBorderColor} ${styling.textAreaBorderWidth}px`};
  padding: 5px ${({ styling }) => `${styling.textAreaPaddingInline}px`};
  font-size: ${({ styling }) => `${styling.textAreaFontSize}px`};
  font-weight: ${({ styling }) => styling.textAreaFontWeight};
  font-family: ${({ styling }) => styling.textAreaFontFamily};
  border-radius: ${({ styling }) => `${styling.textAreaBorderRadius}px`};
  transition: ${(props) => props.theme.transitionMain};

  color: ${({ styling }) => styling.textAreaColor};
  background-color: ${({ styling }) => styling.textAreaBackgroundColor};

  &:hover {
    color: ${({ styling }) => styling.textAreaHoverColor};
    border-color: ${({ styling }) => styling.textAreaHoverBorderColor};
    background-color: ${({ styling }) => styling.textAreaHoverBackgroundColor};
  }

  &::placeholder {
    color: ${({ styling }) => styling.placeholderColor};
    font-size: ${({ styling }) => `${styling.placeholderFontSize}px`};
    font-weight: ${({ styling }) => styling.placeholderFontWeight};
    font-family: ${({ styling }) => styling.placeholderFontFamily};
  }

  &:hover::placeholder {
    color: ${({ styling }) => styling.placeholderHoverColor};
  }
`;

const StyledTextarea = (props) => {
  const { state } = useContext(FormBuilderContext);
  const placeholderText = state.addPlaceholders ? "Example Text" : "";

  return <StyledTextareaBase {...props} placeholder={placeholderText} />;
};



export default StyledTextarea;
